/**
 * Hook to track page views in Google Analytics when location changes
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on location change
    trackPageView(location.pathname + location.search);
  }, [location]);
};

/**
 * Component that tracks page views
 */
export const PageTracker = () => {
  usePageTracking();
  return null;
};